import { Link } from '@/Framework/Router/Next/Link';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import IDealHeader from '@/finsight/ui/components/deals/DealsList/DealHeader/IDealHeader';

import styles from '@/finsight/ui/components/deals/DealsList/DealHeader/dealHeader.scss';

interface ITickerDealNameProps {
  deal: IDealHeader,
}

const TickerDealName = ({ deal }: ITickerDealNameProps) => (
  <div className={ styles.tickerCol }>
    <Tooltip content={ `${ deal.primaryIssuer.name } ${ deal.seriesName }` }>
      <Link
        className={ styles.link }
        to={ deal.link }
        dataTest="dealRowTickerLink"
      >
        { deal.primaryIssuer.issuerTicker } { deal.seriesName } { deal.totalSize }
      </Link>
    </Tooltip>
  </div>
);

export default TickerDealName;
